<template>
	<div>
		<div class="events-layout events-auth-layout">
			<events-header />
			<div class="position-relative">
				<nuxt />
				<chat />
			</div>
		</div>
	</div>
</template>

<script>
import EventsHeader from '~/components/EventsHeader'
import Chat from '~/components/interface/Chat'

export default {
	name: 'Events',
	components: { EventsHeader, Chat }
}
</script>

<style lang="scss">
	.events-auth-layout::before {
		background-image: url('/my/images/events/auth-layout-bg.webp');
	}
</style>
